import React from 'react';
import { IconButton, IDropdownOption, Dropdown, IDropdownProps, TooltipHost, IDropdownStyles } from '@fluentui/react';
import { normalizeDropdownOption } from './DropdownOptionUtils';

export interface tooltipProps {
  tooltipText: string;
}

// Opt-in "X" affordance that resets a single-select dropdown to empty.
export interface clearableProps {
  clearable?: boolean;
  onClear?: () => void;
}
const dropdownStyles: Partial<IDropdownStyles> = {
  dropdownItem: { width: '-webkit-fill-available', height: 'auto !important', minHeight: '36px !important' },
  dropdownItemSelected: { width: '-webkit-fill-available', height: 'auto !important', minHeight: '36px !important' },
};

export default function SimpleDropdown(props: IDropdownProps & tooltipProps & clearableProps) {
  // Keep the clear-affordance props out of the `{...dropdownProps}` spread onto Fluent `Dropdown`.
  const { clearable, onClear, onChange, ...dropdownProps } = props;
  const showClear = Boolean(clearable && props.selectedKey && !props.disabled);

  function renderOption(option: IDropdownOption): JSX.Element {
    return (
      <div role="option" tabIndex={-1}>{option.text}</div>
    );
  }

  return (
    <TooltipHost content={props.tooltipText}>
      <div style={{ position: 'relative' }}>
        <Dropdown
          {...dropdownProps}
          onChange={(event, option, index) => {
            onChange?.(event, normalizeDropdownOption(option, props.placeholder), index);
          }}
          onRenderOption={renderOption}
          ariaLabel={props?.ariaLabel || props?.tooltipText || props?.label || props?.placeholder}
          styles={dropdownStyles}
        />
        {showClear && (
          <IconButton
            iconProps={{ iconName: 'Cancel' }}
            title='Clear'
            ariaLabel='Clear selection'
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onClear?.();
            }}
            styles={{
              root: {
                position: 'absolute',
                right: 28,
                top: '50%',
                transform: 'translateY(-50%)',
                height: 24,
                width: 24,
                zIndex: 10,
              },
              icon: { fontSize: 12 },
            }}
          />
        )}
      </div>
    </TooltipHost>
  );
}
// Generated by GitHub Copilot | Updated on: 2026-08-06 | 2 lines modified | Applied Fluent dropdown accessible name
// Generated by GitHub Copilot | Updated on: 2026-08-11 | 9 lines modified | Blocked placeholder option selection
// Generated by GitHub Copilot | Updated on: 2026-08-14 | 6 lines modified | Restore placeholder clearing with empty key
